import cn from 'clsx'
import { useEffect, useRef, useState } from 'react'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

const ns = `site-sidebar`

interface SidebarProps {
  isActive: boolean
  children: any
  onClose: () => void
}

const Sidebar: React.FC<SidebarProps> = ({ isActive, children, onClose }) => {
  const rootClassnames = cn({
    [`${ns}`]: true,
    [`${ns}--active`]: isActive,
  })

  const sidebarRef = useRef() as React.MutableRefObject<HTMLDivElement>
  const contentRef = useRef() as React.MutableRefObject<HTMLDivElement>
  const [path, setPath] = useState(``)

  const onKeyDownSidebar = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.code === 'Escape') {
      onClose()
    }
  }

  useEffect(() => {
    const contentElement = contentRef.current
    const { href } = window.location

    if (href !== path) {
      setPath(href)
      onClose()
    }

    if (sidebarRef.current) {
      sidebarRef.current.focus()
    }

    if (contentElement && isActive) {
      disableBodyScroll(contentElement, { reserveScrollBarGap: true })
    }

    return () => {
      clearAllBodyScrollLocks()
    }
  }, [isActive, path, onClose])

  return (
    <div
      className={rootClassnames}
      ref={sidebarRef}
      onKeyDown={onKeyDownSidebar}
      tabIndex={1}
    >
      <div className={`${ns}__container`}>
        <div className={`${ns}__backdrop`} onClick={onClose} />
        <section className={`${ns}__section`}>
          <div className={`${ns}__wrapper`}>
            <div className={`${ns}__sidebar`} ref={contentRef}>
              {children}
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default Sidebar
